export default __webpack_public_path__ + "static/media/close.c60167b7.svg";